export function getStatusId(columnId) {
  return parseInt(columnId.split('-')[1], 10);
}
